
import { Component, Prop, Vue } from "vue-property-decorator";
import AdminBadge from "./AdminBadge.vue";
import { PROVIDERS } from "@/helpers/admin-badges";

// Провайдер предмета/оффера бейджем со своим цветом
@Component({ components: { AdminBadge } })
export default class AdminProviderBadge extends Vue {
  @Prop() value: string | undefined | null;

  get meta() {
    return (
      PROVIDERS[String(this.value)] || {
        label: String(this.value),
        icon: "",
        color: "grey"
      }
    );
  }
}
